import { createSelector } from 'reselect';
import { Map, List } from 'immutable';

import { getFormValues } from 'redux-form/immutable';
import { safeGet, safeGetIn } from '@/utils/safeImmutable';

export const getTextField = (name: string) => (state: Map<any, any>) =>
  safeGetIn(state, ['dbAutocomplete', name, 'textField']);
export const getDataSource = (name: string) => (state: Map<any, any>) =>
  safeGetIn(state, ['dbAutocomplete', name, 'dataSource']);
export const getOrigin = (name: string) => (state: Map<any, any>) =>
  safeGetIn(state, ['dbAutocomplete', name, 'origin']) || List([]);
export const getUrl = (name: string) => (state: Map<any, any>) => safeGetIn(state, ['dbAutocomplete', name, 'url']);
export const getChosenText = (name: string) => (state: Map<any, any>) =>
  safeGetIn(state, ['dbAutocomplete', name, 'chosenText']);
export const getAllAutocompletes = (state: Map<any, any>) => safeGet(state, 'dbAutocomplete');
export const getPreload = (name: string) => (state: Map<any, any>) => safeGetIn(state, ['dbAutocomplete', 'preloads', name]);

export const formValues = (formName: string) => (state: Map<any, any>) => getFormValues(formName)(state);

export const getValue = (formName: string, name: string) =>
  createSelector(formValues(formName), (formValues: Map<any, any>) => {
    return (formValues as any).get(name);
  });
